import { Spinner } from '@/components/ui';
import { AthleteRollupTable } from '@/components/evaluation';
import { useCoachAthleteEvalHistory } from '@/hooks/useAthleteHistory';
import { PageHeader } from '@/components/layout';

export default function AthletesPage() {
  const { data: rows, isLoading, isError } = useCoachAthleteEvalHistory({ limit: 50 });

  return (
    <div>
      <PageHeader
        title="My Athletes"
        description="Evaluation history for all athletes across your channels"
      />

      {isLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '64px 0' }}>
          <Spinner size="lg" label="Loading athletes..." />
        </div>
      ) : isError ? (
        <p style={{ color: 'var(--color-danger)', fontSize: '14px', padding: '24px 0' }}>
          Failed to load athlete history.
        </p>
      ) : (
        <div
          style={{
            backgroundColor: 'var(--color-dark-card)',
            border: '1px solid var(--color-border-subtle)',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: 'var(--shadow-card)',
          }}
        >
          <AthleteRollupTable rows={rows ?? []} />
        </div>
      )}
    </div>
  );
}
